import { Typography } from '@mui/material'
import dayjs from 'dayjs'
import { Fragment, ReactNode, useMemo } from 'react'
import { colors } from 'src/theme'
import { TitledTooltip } from 'src/components/shared/TitledTooltip'
import { BulletList } from 'src/components/shared/BulletList'
import React from 'react'
import tw from 'twin.macro'
import { getOnboardingTableStepTitle } from 'src/utils/collectedData'

interface Props {
  failedAt?: string | null
  failedSteps: string[]
  children: ReactNode
}

export const OnboardingFailureReasonTooltip = ({ failedAt, failedSteps, children }: Props) => {
  const text = useMemo(
    () =>
      `Failed ${failedAt ? `at ${dayjs(failedAt).format('MMM D, h:mm A')} ` : ''}due to ${
        failedSteps.length > 1 ? 'multiple' : 'one of the'
      } automated checks failing${failedSteps.length ? ':' : ''}`,
    [failedAt, failedSteps],
  )

  return (
    <TitledTooltip
      title="Onboarding failed"
      content={
        <Fragment>
          <Typography variant="body2" color={colors.SHADES_GREY_300}>
            {text}
          </Typography>
          {!!failedSteps.length && (
            <div css={tw`mt-2`}>
              <BulletList
                variant="body2"
                color={colors.SHADES_GREY_300}
                texts={failedSteps.map(getOnboardingTableStepTitle)}
              />
            </div>
          )}
        </Fragment>
      }
    >
      {children}
    </TitledTooltip>
  )
}
